import React, { useRef, useState } from "react";
import useClickAway from "../utils/useClickAway";
import Button from "./Button";
import styles from "./Modal.module.scss";
export default function Modal(props) {
    var _a;
    const contentRef = useRef(null);
    const [loading, setLoading] = useState(false);
    function close() {
        props.onClose && props.onClose();
    }
    async function ok() {
        try {
            setLoading(true);
            await props.onOk();
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }
    useClickAway(contentRef, close);
    return (React.createElement(React.Fragment, null, props.isOpen && React.createElement("div", { className: styles.overlay },
        React.createElement("div", { ref: contentRef, className: styles.content },
            props.title && React.createElement("h4", null, props.title),
            props.children,
            React.createElement("div", { className: styles.actionButtons },
                props.cancelBtnLabel && React.createElement(Button, { label: props.cancelBtnLabel, onClick: close }),
                React.createElement(Button, { kind: "primary", label: (_a = props.okBtnLabel) !== null && _a !== void 0 ? _a : "Ok", onClick: ok, isLoading: loading, className: styles.okBtn }))))));
}
